export default {
    accounts_export_logs_id: "Id",
    accounts_export_logs_account_id: "Id de cuenta",
    accounts_export_logs_auth_id: "Id. de autorización",
    accounts_export_logs_created_on: "Creado en",
    accounts_export_logs_error_message: "Mensaje de error",
    accounts_export_logs_name: "Nombre",
    accounts_export_logs_output_url: "Archivo",
    accounts_export_project_id: "Id de proyecto",
    accounts_export_status: "Estado",
    accounts_export_status_updated_on: "Actualizado en",
    accounts_export_type: "Tipo",
    accounts_export_processes_records: "Registros procesados",
    accounts_export_total: "Total",
    accounts_export_report: "Reporte",
    accounts_export_status_completed: "Completado",
    accounts_export_status_pending: "Pendiente",
    accounts_export_status_processing: "Procesando",
    accounts_export_status_in_progress: "En progreso",
    accounts_export_status_failed: "Fallido",
    accounts_export_status_error: "Error",
    accounts_export_status_cancelled: "Cancelado",
}